export interface IzikatagovBasicLabelKeyPair<T> {
  label: string;
  key: T;
  icon?: string;
  bgClass?: string;
  sortBy?: string;
  sortDirection?: string;
};
